// Retired handoffs had no owner identity. Clear only Orca's transient editor
// state when the authenticated owner changes; preferences/auth cookies stay intact.
export function prepareEditorBrowserSession(ownerId) {
  try {
    const owner = String(ownerId || '');
    const previous = sessionStorage.getItem('orca.editor.owner.v2');
    if (previous !== owner) {
      for (const key of Object.keys(sessionStorage)) {
        if (key === 'seedance.importedShot' || key === 'orca_deck.i2v_first_frame'
            || key.startsWith('orca.promptAssistant.v2.')) sessionStorage.removeItem(key);
      }
      sessionStorage.setItem('orca.editor.owner.v2', owner);
    }
    // Local handoffs could travel between tabs/accounts and survive for weeks.
    localStorage.removeItem('orca_deck.i2v_first_frame');
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('nostromorama.promptAssistant.sessionId')) localStorage.removeItem(key);
    }
  } catch (_) { /* Storage-disabled browsers still work in memory. */ }
}
